// Static audio-waveform style bar visualization with subtle animation.
export default function Waveform({ bars = 60, height = 80, animated = true, color = "#E10600", muted = "#262626" }) {
  return (
    <div
      className="flex items-end gap-[2px] w-full"
      style={{ height }}
      aria-hidden
    >
      {Array.from({ length: bars }).map((_, i) => {
        const seed = Math.abs(Math.sin(i * 0.55) + Math.cos(i * 0.31));
        const h = 12 + (seed % 1) * 88;
        const isAccent = i % 5 === 0;
        return (
          <span
            key={i}
            className={animated ? "wave-bar" : ""}
            style={{
              flex: 1,
              height: `${h}%`,
              background: isAccent ? color : muted,
              animationDelay: animated ? `${(i % 20) * 0.06}s` : undefined,
            }}
          />
        );
      })}
    </div>
  );
}
